
import { Component, OnInit } from '@angular/core';
import { AnnotationStreamManagement } from './annotation-stream-management.service';
import { isNumeric } from 'rxjs/util/isNumeric';
import { ISubscription } from "rxjs/Subscription";
import { NotificationService } from "../../services/notification.service";
import { TenantRetrieverService } from "../../services/tenant-Retriever.service";

@Component({
    selector: 'mainannotationstreammanagement',
    template: require('./annotation-stream-management.component.html')
})

export class AnnotationStreamManagementComponent implements OnInit{
    ownerId: string;
    streamId: string;
    messageCount: string;
    printHtml: string;
    streamIdBatchToDelete: string[] = [];
    textBoxInput: string;
    tenantName: string;
    tenantNameList : string[];
    errorInFetchingTenantNames: boolean = true;
    guidValidatorRegex = new RegExp("^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$");
    
    responseData: any;
    
    isFetchAnnotationSuccess: boolean;
    isSuccessForMessageCount: boolean;
    isStreamIdSelectedForDelete: boolean;
    isDeleteFailed: boolean;

    constructor(private annotationStreamManagement: AnnotationStreamManagement, private notifier: NotificationService, private tenantRetriever: TenantRetrieverService) {
        this.messageCount = "";
        this.notifier.clear();
    }
    clearMessages() {
        this.notifier.clear();
        this.isFetchAnnotationSuccess = false;
        this.isSuccessForMessageCount = false;
        this.streamIdBatchToDelete = [];
    }

    ngOnInit(): void {
        this.getTenantNames();
    }

    getTenantNames() {
        this.notifier.displayInfo("Fetching Tenant Names ...");
        this.tenantRetriever.getTenant().subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.processGetTenantResponse();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            }
        );
    }

    processGetTenantResponse() {

        if (this.responseData.statusCode === 200) {
            this.tenantNameList = this.responseData.data;
            this.tenantName = this.tenantNameList[0];
            this.errorInFetchingTenantNames = false;
        } else {
            this.errorInFetchingTenantNames = true;
            this.notifier.displayError("Unable to fetch Tenant names");
        }
    }

    getSubscriptionsByMessageCount() {
        this.clearMessages();
        if (this.messageCount !== '') {
            if (!isNumeric(this.messageCount)) {
                this.notifier.displayError("Please enter a valid message count");
                return;
            }      
        }
        this.notifier.displayInfo("Fetching subscriptions from service bus... Please wait");
        if (this.messageCount === '') {
            this.messageCount = "0";
        }
        this.annotationStreamManagement.getSubscriptionsByMessageCount(this.messageCount, this.tenantName).subscribe(
            resp => {
                this.clearMessages();
                if (resp.statusCode === 200) {
                    this.responseData = resp.data;
                    this.isSuccessForMessageCount = true;
                    this.notifier.displaySuccess("Successfully fetched " + this.responseData.length + " subscriptions");
                } else {
                    this.notifier.displayError(resp.message as string);
                }
            },
            error => {
                this.clearMessages();
                this.notifier.displayApiResponseError(error);
            });
    }

    getAllAnnotationStreams() {
        this.clearMessages();
        this.isFetchAnnotationSuccess = false;
        this.notifier.displayInfo("Fetching all annotation streams... Please wait");
        this.annotationStreamManagement.getAllAnnotationStreams( this.tenantName).subscribe(
            resp => {
                this.processAnnotationStreamResponse(resp, "Successfully fetched " + resp.data.length + " annotation streams");
            },
            error => {
                this.clearMessages();
                this.notifier.displayError((error.statusCode !== 0) ? error.data as string: 'server error');
            });
    }

    annotationStreamByStreamId() {
        this.clearMessages();
        if (!this.guidValidatorRegex.test(this.streamId)) {
            this.notifier.displayError('Please enter a valid stream Id');
            return;
        }
        this.notifier.displayInfo("Fetching annotation stream details... Please wait");
        this.annotationStreamManagement.annotationStreamByStreamId(this.streamId, this.tenantName).subscribe(
            resp => {
                this.processAnnotationStreamResponse(resp, "Successfully fetched the details of the annotation stream");
            },
            error => {
                this.clearMessages();
                this.notifier.displayApiResponseError(error);
            });
    }

    annotationStreamByOwnerId() {
        this.clearMessages();
        if (!this.guidValidatorRegex.test(this.ownerId)) {
            this.notifier.displayError('Please enter a valid owner Id');
            return;
        }
        this.notifier.displayInfo("Fetching annotation stream details... Please wait");
        this.annotationStreamManagement.annotationStreamsByOwnerId(this.ownerId, this.tenantName).subscribe(
            resp => {
                this.processAnnotationStreamResponse(resp, "Successfully fetched " + resp.data.length + " annotation streams");
            },
            error => {
                this.clearMessages();
                this.notifier.displayError((error.statusCode !== 0) ? error.data as string : 'server error');
            });
    }

    deleteAnnotationStreamsBatch() {
        this.notifier.clear();
        var deleteInfoMessage = "";
        var errorMessageWithActivityId = "";
        if (this.isStreamIdSelectedForDelete === false) {
            this.notifier.displayError('Please select stream Ids to delete');
            return;
        }
        this.isStreamIdSelectedForDelete = false;
        this.notifier.displayInfo("Deleting annotation streams... Please wait");
        this.annotationStreamManagement.deleteStreamBatch(this.streamIdBatchToDelete , this.tenantName).subscribe(
            resp => {
                if (resp.statusCode === 200) {
                    this.clearMessages();
                    this.responseData = resp.data;
                    for (let item of this.responseData) {
                        if (item.isSuccess === false) {
                            this.isDeleteFailed = true;
                            deleteInfoMessage += item.streamId+" ; ";
                            errorMessageWithActivityId= item.errorMessage;
                        }
                    }
                    if (this.isDeleteFailed) {
                        this.isDeleteFailed = false;
                        this.notifier.displayError("Error while deleting: " + deleteInfoMessage + " " + errorMessageWithActivityId);
                    } else {
                        this.notifier.displaySuccess("Successfully deleted the selected annotation streams");
                    }
                } else {
                    this.notifier.displayError(resp.message as string);
                }
                
            },
            error => {
                this.isStreamIdSelectedForDelete = true;
                this.notifier.displayApiResponseError(error);
            });
    }

    getAnnotationStreamToDelete(e, selectedStreamIdToDelete: string) {
        if (e.target.checked) {
            this.streamIdBatchToDelete.push(selectedStreamIdToDelete);
            this.isStreamIdSelectedForDelete = true;
        } else {
            var index = this.streamIdBatchToDelete.indexOf(selectedStreamIdToDelete);
            if (index > -1) {
                this.streamIdBatchToDelete.splice(index, 1);
            }
        }
    }

    batchDeleteStreams() {
        this.clearMessages();
        if (this.textBoxInput === undefined || this.textBoxInput.trim() === "") {
            this.notifier.displayError("Please enter stream ids to delete");
            return;
        }
        var textInLines = this.textBoxInput.split(/\n/);
        for (var st of textInLines) {
            if (st !== "") {
                var streamId = st.split(/[\s,\,]/)[0];
                if (!this.guidValidatorRegex.test(streamId)) {
                    this.notifier.displayError('Please enter valid stream Ids');
                    return;
                }
                this.streamIdBatchToDelete.push(streamId);
            }
        }
        this.isStreamIdSelectedForDelete = true;
        this.deleteAnnotationStreamsBatch();
    }

    initializetab() {
        this.clearMessages();
    }

    prettyPrint(jsonObject:any) {
        return JSON.stringify(jsonObject, null, 2).replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
    }

    processAnnotationStreamResponse(resp: any, errorMessage: any) {
        this.clearMessages();
        if (resp.statusCode === 200) {
            this.responseData = resp.data;
            this.notifier.displaySuccess(errorMessage);
            this.isFetchAnnotationSuccess = true;
        } else {
            this.notifier.displayError(resp.message as string);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/annotationStreamManagement/annotation-stream-management.component.ts
 **/